import moment from 'moment-timezone';

export const parseDate = (date, outputFormat) =>
  moment(date).format(outputFormat);
